/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Failure_RejectedInputs */

const en_sync_failure_rejected = /** @type {(inputs: Sync_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central refused the last state sent. See below why, fix it, then send again.`)
};

/**
* | output |
* | --- |
* | "Business Central refused the last state sent. See below why, fix it, then send again." |
*
* @param {Sync_Failure_RejectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_failure_rejected = /** @type {((inputs?: Sync_Failure_RejectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Failure_RejectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_failure_rejected(inputs)
});